// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-ctn-s3oPUj{flex-direction:column;justify-content:space-between;align-items:flex-start;margin-left:16px;display:flex}.button-ctn-s3oPUj .generate-icon-KhwQi4{margin-right:4px;position:relative;top:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-ctn": `button-ctn-s3oPUj`,
	"buttonCtn": `button-ctn-s3oPUj`,
	"generate-icon": `generate-icon-KhwQi4`,
	"generateIcon": `generate-icon-KhwQi4`
};
export default ___CSS_LOADER_EXPORT___;
